export enum Feature {
  Landing,
  Payment,
  Register
}
